import {_delete, get, post, put} from "../utils/http.ts";
import {Patient, PatientFormData} from "../context/PatientsContext.tsx";
import {BASE_URL} from "./index.ts";
import {RecordingUnparsed} from "../context/RecordingsContext.tsx";
import {CreatePatientBody} from "../utils/types.ts";
import {formatDobForBackend} from "../utils/dates.ts";

export async function getPatients(patientName?: string) {
  const url = new URL(`${BASE_URL}/patients`);
  if(patientName) url.searchParams.set('name', patientName);
  return get<Patient[]>(url);
}

export async function getPatientRecordings(patientId: number) {
  const url = new URL(`${BASE_URL}/recordings`);
  url.searchParams.set('patient_id', patientId.toString());
  return get<RecordingUnparsed[]>(url);
}

export async function createPatient(patientFormData: PatientFormData): Promise<Patient> {
  const body: CreatePatientBody = {
    first_name: patientFormData.firstName,
    last_name: patientFormData.lastName,
    dob: patientFormData.dob ? formatDobForBackend(patientFormData.dob) : null,
    gender: patientFormData.gender ?? null,
  }
  return post<Patient>(new URL(`${BASE_URL}/patients`), {
    body: body,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export async function editPatient(patientFormData: PatientFormData, patientId: number): Promise<Patient> {
  const body: CreatePatientBody = {
    first_name: patientFormData.firstName,
    last_name: patientFormData.lastName,
    dob: patientFormData.dob ? formatDobForBackend(patientFormData.dob) : null,
    gender: patientFormData.gender ?? null,
  }
  return put<Patient>(new URL(`${BASE_URL}/patients/${patientId}`), {
    body: body,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export async function deletePatient(patientId: number): Promise<void> {
  return _delete(new URL(`${BASE_URL}/patients/${patientId}`));
}